import { render, staticRenderFns } from "./AccountSelectionItem.vue?vue&type=template&id=564f4b06&scoped=true"
import script from "./AccountSelectionItem.vue?vue&type=script&lang=js"
export * from "./AccountSelectionItem.vue?vue&type=script&lang=js"
import style0 from "./AccountSelectionItem.vue?vue&type=style&index=0&id=564f4b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f4b06",
  null
  
)

export default component.exports